// import React, { useState, useEffect } from 'react';
// import './regularImage.css';
// import Img1 from '../../assets/images/sec-1.png';
// import Img2 from '../../assets/images/sec-2.png';
// import Img3 from '../../assets/images/sec-3.png';
// import Img4 from '../../assets/images/sec-4.png';
// import Img5 from '../../assets/images/sec-5.png';
// import { ProgressBar } from 'react-bootstrap';

// const RegularImageSlider = ({ isRtl }) => {

//     const data = [
//         {
//             title: {
//                 en: 'Establishments Data Management',
//                 ar: 'إدارة ملف المنشأة',
//             },
//             descriptions: {
//                 en: [
//                     'HR PASS enables you to manage, store, and update all official data and documents of your establishment, Designed to meet the highest standards of quality, confidentiality, and security.',
//                 ],
//                 ar: [
//                     'يتيح لك نظام اتش ار باس  إدارة وحفظ وتعديل كافة بيانات و الملفات الرسمـية للمنشأة من منصة واحدة تتمـتع بأعـلى معـاييـر الجـودة والسرية والأمـان، و إمكـانـيـة تنبيـه صـاحـب المنشأة بتواريخ جميع الأوراق الرسمـية للمنشأة وسهـلة الوصول إليها من أي مكان و في أي وقت.',
//                 ],
//             },
//             imgSrc: Img1,
//             imgClass: 'fullImg',
//         },
//         {
//             title: {
//                 en: 'Employee Data Management',
//                 ar: 'إدارة بيانات الموظفين',
//             },
//             descriptions: {
//                 en: [
//                     'HR PASS enables you to manage, save, and modify all employee data from a single pla orm that adheres to the highest standards of quality and security.',
//                     'Access employee data from anywhere, at any ensuring ﬂexibility and control over HR opera ons.',
//                 ],
//                 ar: [
//                     'تيح لك نظام اتش ار باس  إدارة وحفظ وتعديل كافة بيانات الموظفين من منصة واحدة تتمتع بأعلى معايير الجودة و الأمـان.  يمكن اسـتخـدامهـا و الحصول عليهـا من أي مكـان، ويسهل البحث فيها للوصول إلى أي معلومة عن أي موظف في أي وقت.',
//                 ]
//             },
//             imgSrc: Img2,
//             imgClass: 'halfImg',
//         },
//         {
//             title: {
//                 en: 'Speed of Salary Payment',
//                 ar: 'سرعة تسديد الرواتب',
//             },
//             descriptions: {
//                 en: [
//                     'With HR PASS, salary calcula ons are veriﬁed, automated, and organized in full compliance with the laws of the Ministry of Human Resources and Emira sa on(MOHRE).',
//                     'Say goodbye to manual calcula ons and reduce human error with automa c, precise salary computa ons.',
//                 ],
//                 ar: [
//                     'مـع نظــام اتش ار باس ، حـسابـات موثـقـة وتلقــائية و منظـمـة للرواتب بالتوافق مع قـوانين وزارة الموارد البشرية و التوطـين، وداعاً للحسابات اليدوية وفوضى الجداول والبيانات المبعثرة.',
//                 ]
//             },
//             imgSrc: Img3,
//             imgClass: 'halfImg',

//         },
//         {
//             title: {
//                 en: 'A endance and Leaves',
//                 ar: 'الحضور و الانصراف',
//             },
//             descriptions: {
//                 en: [
//                     'Track employee a endance remotely with ease.',
//                     'Say goodbye to manual employee a endance and departure recording and manual data transfer for payroll calcula on.',
//                 ],
//                 ar: [
//                     'وداعاً لنقل بيانات الحضور والانصراف وسهولة تسجيلها وتتبع مواقع المـوظـفـين  و سهـولـة ربـط نظـام اتش ار بـاس مع أجـهـزة البصمة،  وربطها بالرواتب والإجازات والغيابات مباشرة.',
//                 ]
//             },
//             imgSrc: Img4,
//             imgClass: 'halfImg',

//         },
//         {
//             title: {
//                 en: 'Letters Requests',
//                 ar: 'طـلبــات الخـطابات',
//             },
//             descriptions: {
//                 en: [
//                     'With HR PASS, both the facility owner and employees can easily request various types of le ers directly through the system.These le ers comply with the requirements of the Ministry of Human Resources and Emira sa on(MOHRE), ensuring that they are documented and comprehensive to protect all par es and prevent future disputes Employees and management can request diﬀerent types of le ers (e.g., salary cer ﬁcates, NOC, experience le ers) directly through the pla orm..The HR team can create and customize le er templates to suit various needs, streamlining the process for repe ve requests.',
//                 ],
//                 ar: [
//                     'يمكن لصاحب المنشأة والموظفين طلب الخطابات بمختلف أنواعها مباشرة عبر نظام اتش ار باس، بالتوافق مع متطلبات وزارة الموارد البشرية والتوطين لتكون موثقة وشاملة لضمان جميع الحقوق بما يمنع حدوث خلافات مستقبلية ، ويستطيع فريق الموارد البشرية إنشاء قوالب خطابات قابلة للتخصيص.',
//                 ],
//             },
//             imgSrc: Img5,
//             imgClass: 'fullImg',
//         },
//         {
//             title: {
//                 en: 'Employee Leaves',
//                 ar: 'إجــازات الموظـفين',
//             },
//             descriptions: {
//                 en: [
//                     'HR PASS allows for seamless management and tracking of employee leave balances, providing high accuracy and full compliance with the laws of the Ministry of Human Resources and Emira sa on(MOHRE) in the UAE.',
//                 ],
//                 ar: [
//                     'سهولة حساب وتتبع إجـازات الموظفين والوصول إلى أرصدة الموظفين لجميع أنواع الاجازات بدقة عالية و بما يتوافق مع قـوانين وزارة الموارد البشرية و التـوطـين في دولـة الإمـارات العربية المتحدة.',
//                 ]
//             },
//             imgSrc: Img3,
//             imgClass: 'halfImg',
//         },
//         {
//             title: {
//                 en: 'Employee Warnings',
//                 ar: 'إنـذارات المـوظفـين',
//             },
//             descriptions: {
//                 en: [
//                     'HR PASS enables you to create and manage internal organiza onal regula ons, document employee penal es, and maintain comprehensive records throughout an employee’s service',
//                 ],
//                 ar: [
//                     'إنشاء لوائح تنظيمة داخلية  للمنشأة و توثيق جـميع أنواع الجـزاءات للموظـفين و الحـفـاظ على سجلاتهم و سهـولة الوصول إليها طوال خدمة الموظف.',
//                 ]
//             },
//             imgSrc: Img3,
//             imgClass: 'halfImg',
//         },
//         {
//             title: {
//                 en: 'End Of Service',
//                 ar: 'نهـاية الخــدمـة',
//             },
//             descriptions: {
//                 en: [
//                     'HR PASS simpliﬁes the end-of-service process by ensuring accurate calcula ons and proper documenta on, in full compliance with the laws of the Ministry of Human Resources and Emira sa on(MOHRE) in the UAE.',
//                 ],
//                 ar: [
//                     'يتيح لك نظام حساب نهاية الخدمة و براءة ذمـة الموظـفين مـن جمـيع الاستحـقـاقـات وتـوثيـقـهـا حـسب قـوانـين وزارة الموارد البشرية والتوطين في دولة الإمارات العربية المتحدة.',
//                 ]
//             },
//             imgSrc: Img3,
//             imgClass: 'halfImg',
//         },
//         {
//             title: {
//                 en: 'Employee Files',
//                 ar: 'ملفـات المـوظـفين',
//             },
//             descriptions: {
//                 en: [
//                     'HR PASS streamlines the management of employee ﬁles, ensuring mely alerts and easy access to important documents.',
//                     'Expira on Date Alerts: Automa cally no fy the facility owner of upcoming expira on dates for oﬃcial employee documents, such as visas, IDs, contracts, and cer ﬁca ons, ensuring mely renewals',
//                 ],
//                 ar: [
//                     'تنبيه صاحب المنشأة بجميع تواريخ انتهاء الأوراق الرسمية للمـوظـفـين و الحـفـاظ عـلى ملفـات الموظـفـين و سهـولـة الوصول للأوراق الرسمية للموظـف من أي مكـان و في أي وقت.',
//                 ]
//             },
//             imgSrc: Img3,
//             imgClass: 'halfImg',
//         },
//     ];

//     const [currentIndex, setCurrentIndex] = useState(0);
//     const [progress, setProgress] = useState(0);
//     const [isTransitioning, setIsTransitioning] = useState(false);

//     useEffect(() => {
//         let interval;
//         const handleProgress = () => {
//             setProgress((prev) => {
//                 if (prev < 100) return prev + 1;
//                 return 0;
//             });
//         };

//         if (progress < 100) {
//             interval = setInterval(handleProgress, 100); // Fill the bar in 10s
//         } else {
//             setIsTransitioning(true);
//             setTimeout(() => {
//                 setCurrentIndex((prevIndex) => (prevIndex + 1) % data.length); // Loop through slides
//                 setIsTransitioning(false);
//                 setProgress(0); // Reset progress
//             }, 800); // This should match your CSS transition duration
//         }

//         return () => clearInterval(interval); // Clean up interval on component unmount
//     }, [progress]);

//     const currentSlide = data[currentIndex];

//     return (
//         <>
//             <section className={`homePageContent`} dir={isRtl ? 'rtl' : 'ltr'}>
//                 <div className="">
//                     <div className="row align-items-stretch">
//                         {/* Content Box */}
//                         <div className="col-lg-6 col-md-12 col-12 order-lg-1 order-md-2 order-2">
//                             <div className="progresBox">
//                                 <ProgressBar now={progress} />
//                             </div>
//                             <div
//                                 className={`content-box ${isTransitioning ? 'fade-out' : 'fade-in'}`} // Add your fade-in/out animations
//                             >
//                                 <h2 className='title'>{isRtl ? currentSlide.title.ar : currentSlide.title.en}</h2>
//                                 <p className="desc">
//                                     {isRtl
//                                         ? currentSlide.descriptions.ar.join(' ') // Join array items into a single string
//                                         : currentSlide.descriptions.en.join(' ')}
//                                 </p>
//                             </div>
//                         </div>

//                         {/* Image Box */}
//                         <div className="col-lg-6 col-md-12 col-12 order-lg-2 order-md-1 order-1">
//                             <div
//                                 className={`img-box ${isTransitioning ? 'fade-out' : 'fade-in'}`} // Add your fade-in/out animations
//                             >
//                                 <img src={currentSlide.imgSrc} 
//                                     className={`${currentSlide.imgClass} ${isRtl ? 'rtl-image' : ''}`}
//                                  alt={isRtl ? currentSlide.title.ar : currentSlide.title.en} />
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//         </>
//     );
// };

// export default RegularImageSlider;











// import React from 'react';
// import './regularImage.css';
// import Img1 from '../../assets/images/sec-1.png';
// import Img2 from '../../assets/images/sec-2.png';
// import Img3 from '../../assets/images/sec-3.png';
// import Img4 from '../../assets/images/sec-4.png';
// import Img5 from '../../assets/images/sec-5.png';
// import { ProgressBar } from 'react-bootstrap';

// const RegularImageSlider = ({ isRtl }) => {
//     const data = [
//         {
//             title: { en: 'Establishments Data Management', ar: 'إدارة ملف المنشأة' },
//             descriptions: {
//                 en: ['HR PASS enables you to manage, store, and update all official data and documents of your establishment.'],
//                 ar: ['يتيح لك نظام اتش ار باس  إدارة وحفظ وتعديل كافة بيانات و الملفات الرسمـية للمنشأة.'],
//             },
//             imgSrc: Img1,
//             imgClass: 'fullImg',
//         },
//         {
//             title: { en: 'Employee Data Management', ar: 'إدارة بيانات الموظفين' },
//             descriptions: {
//                 en: ['HR PASS enables you to manage, save, and modify all employee data from a single platform.'],
//                 ar: ['تيح لك نظام اتش ار باس  إدارة وحفظ وتعديل كافة بيانات الموظفين من منصة واحدة.'],
//             },
//             imgSrc: Img2,
//             imgClass: 'halfImg',
//         },
//         {
//             title: { en: 'Speed of Salary Payment', ar: 'سرعة تسديد الرواتب' },
//             descriptions: {
//                 en: ['With HR PASS, salary calculations are verified, automated, and organized in full compliance with the laws of the Ministry of Human Resources and Emiratisation(MOHRE).'],
//                 ar: ['مع نظام اتش ار باس، حسابات موثقة وتلقائية ومنظمة للرواتب بالتوافق مع قوانين وزارة الموارد البشرية والتوطين.'],
//             },
//             imgSrc: Img3,
//             imgClass: 'halfImg',
//         },
//         {
//             title: { en: 'Attendance and Leaves', ar: 'الحضور والانصراف' },
//             descriptions: {
//                 en: ['Track employee attendance remotely with ease.'],
//                 ar: ['وداعاً لنقل بيانات الحضور والانصراف وسهولة تسجيلها.'],
//             },
//             imgSrc: Img4,
//             imgClass: 'halfImg',
//         },
//         {
//             title: { en: 'Letters Requests', ar: 'طلبات الخطابات' },
//             descriptions: {
//                 en: ['With HR PASS, both the facility owner and employees can easily request various types of letters directly through the system.'],
//                 ar: ['يمكن لصاحب المنشأة والموظفين طلب الخطابات بمختلف أنواعها مباشرة عبر نظام اتش ار باس.'],
//             },
//             imgSrc: Img5,
//             imgClass: 'fullImg',
//         },
//     ];

//     return (
//         <section className={`homePageContent`} dir={isRtl ? 'rtl' : 'ltr'}>
//             <div className="">
//                 <div className="row align-items-stretch">
//                     {/* Content Box - This will map the text */}
//                     <div className="col-lg-6 col-md-12 col-12">
//                         <div className="progresBox">
//                             <ProgressBar now={100} /> {/* Assuming full progress for each item */}
//                         </div>
//                         {data.map((slide, index) => (
//                             <div key={index} className="content-box">
//                                 <h2 className="title">{isRtl ? slide.title.ar : slide.title.en}</h2>
//                                 <p className="desc">
//                                     {isRtl
//                                         ? slide.descriptions.ar.join(' ') // Join array items into a single string
//                                         : slide.descriptions.en.join(' ')}
//                                 </p>
//                             </div>
//                         ))}
//                     </div>

//                     {/* Image Box - This will map the images */}
//                     <div className="col-lg-6 col-md-12 col-12">
//                         {data.map((slide, index) => (
//                             <div key={index} className="img-box">
//                                 <img
//                                     src={slide.imgSrc}
//                                     className={`${slide.imgClass} ${isRtl ? 'rtl-image' : ''}`}
//                                     alt={isRtl ? slide.title.ar : slide.title.en}
//                                 />
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default RegularImageSlider;


// import React, { useState, useEffect } from 'react';
// import './regularImage.css';
// import { ProgressBar } from 'react-bootstrap';
// // import Img1 from '../../assets/images/1.jpg';
// // import Img2 from '../../assets/images/2.jpg';
// // import Img3 from '../../assets/images/3.jpg';
// // import Img4 from '../../assets/images/4.jpg';
// // import Img5 from '../../assets/images/5.jpg';

// import Img1 from '../../assets/images/sec-1.png';
// import Img2 from '../../assets/images/sec-2.png';
// import Img3 from '../../assets/images/sec-3.png';
// import Img4 from '../../assets/images/sec-4.png';
// import Img5 from '../../assets/images/sec-5.png';

// const RegularImageSlider = ({ isRtl }) => {
//     const data = [
//             {
//                 title: { en: 'Establishments Data Management', ar: 'إدارة ملف المنشأة' },
//                 descriptions: {
//                     en: ['HR PASS enables you to manage, store, and update all official data and documents of your establishment.'],
//                     ar: ['يتيح لك نظام اتش ار باس  إدارة وحفظ وتعديل كافة بيانات و الملفات الرسمـية للمنشأة.'],
//                 },
//                 imgSrc: Img1,
//                 imgClass: 'fullImg',
//             },
//             {
//                 title: { en: 'Employee Data Management', ar: 'إدارة بيانات الموظفين' },
//                 descriptions: {
//                     en: ['HR PASS enables you to manage, save, and modify all employee data from a single platform.'],
//                     ar: ['تيح لك نظام اتش ار باس  إدارة وحفظ وتعديل كافة بيانات الموظفين من منصة واحدة.'],
//                 },
//                 imgSrc: Img2,
//                 imgClass: 'halfImg',
//             },
//             {
//                 title: { en: 'Speed of Salary Payment', ar: 'سرعة تسديد الرواتب' },
//                 descriptions: {
//                     en: ['With HR PASS, salary calculations are verified, automated, and organized in full compliance with the laws of the Ministry of Human Resources and Emiratisation(MOHRE).'],
//                     ar: ['مع نظام اتش ار باس، حسابات موثقة وتلقائية ومنظمة للرواتب بالتوافق مع قوانين وزارة الموارد البشرية والتوطين.'],
//                 },
//                 imgSrc: Img3,
//                 imgClass: 'halfImg',
//             },
//             {
//                 title: { en: 'Attendance and Leaves', ar: 'الحضور والانصراف' },
//                 descriptions: {
//                     en: ['Track employee attendance remotely with ease.'],
//                     ar: ['وداعاً لنقل بيانات الحضور والانصراف وسهولة تسجيلها.'],
//                 },
//                 imgSrc: Img4,
//                 imgClass: 'halfImg',
//             },
//             {
//                 title: { en: 'Letters Requests', ar: 'طلبات الخطابات' },
//                 descriptions: {
//                     en: ['With HR PASS, both the facility owner and employees can easily request various types of letters directly through the system.'],
//                     ar: ['يمكن لصاحب المنشأة والموظفين طلب الخطابات بمختلف أنواعها مباشرة عبر نظام اتش ار باس.'],
//                 },
//                 imgSrc: Img5,
//                 imgClass: 'fullImg',
//             },
//         ];

//     const [activeIndex, setActiveIndex] = useState(0);
//     const [progress, setProgress] = useState(0);

//     useEffect(() => {
//         let startTime = Date.now();

//         const timer = setInterval(() => {
//             const elapsedTime = (Date.now() - startTime) / 1000;

//             if (elapsedTime <= 10) {
//                 // Update progress bar during 10 seconds
//                 setProgress((elapsedTime / 10) * 100);
//             } else if (elapsedTime > 10 && elapsedTime <= 11) {
//                 // Pause for 1 second after 10 seconds
//                 setProgress(100);
//             } else {
//                 // Switch to the next slide after 11 seconds
//                 setActiveIndex((prevIndex) => (prevIndex + 1) % data.length);
//                 setProgress(0);
//                 startTime = Date.now(); // Reset timer for the next slide
//             }
//         }, 50); // Update every 50ms for smoother progress bar

//         return () => clearInterval(timer);
//     }, [data.length]);

//     return (
//         <section className={`homePageContent`} dir={isRtl ? 'rtl' : 'ltr'}>
//             <div className="">
//                 <div className="row align-items-stretch">
//                     {/* Content Box */}
//                     <div className="col-lg-6 col-md-12 col-12">
//                         <div className="progresBox">
//                             <ProgressBar now={progress} max={100} />
//                         </div>
//                         {data.map((slide, index) => (
//                             <div
//                                 key={index}
//                                 className={`content-box ${activeIndex === index ? 'active' : ''}`}
//                                 style={{
//                                     height: activeIndex === index ? '200px' : '50px',
//                                 }}
//                             >
//                                 <h2 className="title">{isRtl ? slide.title.ar : slide.title.en}</h2>
//                                 <p className="desc">
//                                     {isRtl
//                                         ? slide.descriptions.ar.join(' ')
//                                         : slide.descriptions.en.join(' ')}
//                                 </p>
//                             </div>
//                         ))}
//                     </div>

//                     {/* Image Box */}
//                     <div className="col-lg-6 col-md-12 col-12">
//                         <div className="img-box">
//                             <img
//                                 src={data[activeIndex].imgSrc}
//                                 className={`${data[activeIndex].imgClass}`}
//                                 alt={isRtl ? data[activeIndex].title.ar : data[activeIndex].title.en}
//                             />
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default RegularImageSlider;






// import React, { useState, useEffect } from 'react';
// import './regularImage.css';
// import { ProgressBar } from 'react-bootstrap';

// const RegularImageSlider = ({ slides, intervalTime = 5000, isRtl = false, currentIndex, setCurrentIndex }) => {
//     const [isTransitioning, setIsTransitioning] = useState(false);
//     const [progress, setProgress] = useState(0);

//     // Preload all images
//     useEffect(() => {
//         slides.forEach((slide) => {
//             const img = new Image();
//             img.src = slide.imgSrc;
//         });
//     }, [slides]);

//     useEffect(() => {
//         const slideInterval = setInterval(() => {
//             setIsTransitioning(true); // Start transition

//             setTimeout(() => {
//                 setCurrentIndex((prev) => (prev + 1) % slides.length); // Move to the next slide
//                 setIsTransitioning(false); // End transition
//             }, 800); // Match CSS transition duration
//         }, intervalTime);

//         return () => clearInterval(slideInterval); // Cleanup on unmount
//     }, [slides.length, intervalTime]);

//     const currentSlide = slides[currentIndex];

//     return (
//         <section className="regularImageComponent" id='regularImageComponent'>
//             <div className="h-100">
//                 <div className="row align-items-center h-100">
//                     {/* Content Section */}
//                     <div
//                         className={`col-lg-6 col-12 order-lg-1 order-md-2 order-2 content-box ${isTransitioning
//                             ? isRtl
//                                 ? 'slide-out-right'
//                                 : 'slide-out-left'
//                             : isRtl
//                                 ? 'slide-in-right'
//                                 : 'slide-in-left'
//                             }`}
//                     >
//                         <p className="title">{currentSlide.title}</p>
//                         {currentSlide.descriptions.map((desc, idx) => (
//                             <p className="desc" key={idx}>
//                                 {desc}
//                             </p>
//                         ))}
//                     </div>

//                     {/* Image Section */}
//                     <div
//                         className={`col-lg-6 col-12 order-lg-2 order-md-1 order-1 img-box p-0 ${isTransitioning
//                             ? isRtl
//                                 ? 'slide-out-left'
//                                 : 'slide-out-right'
//                             : isRtl
//                                 ? 'slide-in-left'
//                                 : 'slide-in-right'
//                             }`}
//                     >
//                         <img
//                             src={currentSlide.imgSrc}
//                             className={`${currentSlide.imgClass} ${isRtl ? 'rtl-image' : ''}`}
//                             // className={currentSlide.imgClass}
//                             alt="Illustration"
//                         />
//                     </div>
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default RegularImageSlider;



import React, { useState, useEffect } from "react";
import "./regularImage.css";

const RegularImageSlider = ({
    slides,
    intervalTime = 5000,
    isRtl = false,
    currentIndex,
    setCurrentIndex,
    pauseTransition
}) => {
    const [isTransitioning, setIsTransitioning] = useState(false);
    const [progress, setProgress] = useState(0);

    // Preload all images
    useEffect(() => {
        slides.forEach((slide) => {
            const img = new Image();
            img.src = slide.imgSrc;
        });
    }, [slides]);

    useEffect(() => {
        const slideInterval = setInterval(() => {
            setIsTransitioning(!pauseTransition); // Start transition

            setTimeout(() => {
                if (!pauseTransition) {
                    setCurrentIndex((prev) => (prev + 1) % slides.length); // Move to the next slide
                    setIsTransitioning(false); // End transition
                }
            }, 800); // Match CSS transition duration
        }, intervalTime);

        return () => clearInterval(slideInterval); // Cleanup on unmount
    }, [slides.length, intervalTime, setCurrentIndex, pauseTransition]);

    // Progress bar logic
    useEffect(() => {
        let progressInterval;

        const startProgress = () => {
            setProgress(0); // Instantly reset progress to 0
            progressInterval = setInterval(() => {
                setProgress((prev) => {
                    const nextProgress = prev + 100 / (intervalTime / 100);
                    if (nextProgress >= 100) {
                        clearInterval(progressInterval); // Stop when complete
                    }
                    return nextProgress;
                });
            }, 100);
        };

        if (!pauseTransition)
            startProgress();
        else setProgress(0)
        return () => clearInterval(progressInterval); // Cleanup on unmount or slide change
    }, [currentIndex, intervalTime, pauseTransition]);

    const currentSlide = slides[currentIndex];

    return (
        <section className="regularImageComponent" id="regularImageComponent">
            <div className="h-100">
                {/* Custom Progress Bar */}
                <div className="custom-progress-bar">
                    <div
                        className="progress-bar-fill"
                        style={{ width: `${progress}%` }}
                    ></div>
                </div>

                <div className="row align-items-center h-100">
                    {/* Content Section */}
                    <div
                        className={`col-lg-6 col-12 order-lg-1 order-md-2 order-2 content-box ${isTransitioning
                            ? isRtl
                                ? "slide-out-right"
                                : "slide-out-left"
                            : ""
                            }`}
                    >
                        <p className="title">{currentSlide.title}</p>
                        {currentSlide.descriptions.map((desc, idx) => (
                            <p className="desc" key={idx}>
                                {desc}
                            </p>
                        ))}
                    </div>

                    {/* Image Section */}
                    <div
                        className={`col-lg-6 col-12 order-lg-2 order-md-1 order-1 img-box p-0 ${isTransitioning
                            ? isRtl
                                ? "slide-out-left"
                                : "slide-out-right"
                            : ""
                            }`}
                    >
                        <img
                            src={currentSlide.imgSrc}
                            className={`${currentSlide.imgClass} ${isRtl ? "rtl-image" : ""
                                }`}
                            alt="Illustration"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default RegularImageSlider;
